import React from 'react';
import PropTypes from 'prop-types';
import Parser from './Parser';

export default function EmbeddedPost(props) {
  var className = props.className,
      href = props.href,
      width = props.width,
      showText = props.showText,
      children = props.children,
      onParse = props.onParse;


  return React.createElement(
    Parser,
    { className: className, onParse: onParse },
    React.createElement(
      'div',
      {
        className: 'fb-post',
        'data-href': href,
        'data-width': width,
        'data-show-text': showText
      },
      children
    )
  );
}

EmbeddedPost.propTypes = {
  className: PropTypes.string,
  href: PropTypes.string.isRequired,
  width: PropTypes.oneOfType([PropTypes.number.isRequired, PropTypes.string.isRequired]),
  showText: PropTypes.bool.isRequired,
  children: PropTypes.node,
  onParse: PropTypes.func
};

EmbeddedPost.defaultProps = {
  href: 'http://www.facebook.com',
  width: 500, // 350 - 750
  showText: false,
  children: undefined,
  className: undefined,
  onParse: undefined
};
//# sourceMappingURL=EmbeddedPost.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-facebook/lib/EmbeddedPost.js
// module id = 840
// module chunks = 0